export const build = { date:"2026-02-12.1051", stage:"alpha" }
